{
  "0-30 Days": "0-30 Days",
  "0-6 Months": "0-6 Months",
  "12-18 Months": "12-18 Months",
  "18+ Months": "18+ Months",
  "30+ Days": "30+ Days",
  "31-60 Days": "31-60 Days",
  "6-12 Months": "6-12 Months",
  "60+ Days": "60+ Days",
  "61-90 Days": "61-90 Days",
  "90+ Days": "90+ Days",
  "91+ Days": "91+ Days",
  "Abandoned": "Abandoned",
  "Active": "Active",
  "Add Contact Info": "Add Contact Info",
  "Add to Waitlist": "Add to Waitlist",
  "Address": "Address",
  "All": "All",
  "Answered": "Answered",
  "Apply": "Apply",
  "Back": "Back",
  "Balance: {{overdueAmount}}": "Balance: {{overdueAmount}}",
  "Birthday Date Range": "Birthday Date Range",
  "Birthdays": "Birthdays",
  "CSV": "CSV",
  "Call": "Call",
  "Call answered by {{person}}": "Call answered by {{person}}",
  "Call placed by {{person}}": "Call placed by {{person}}",
  "Calls are not analyzed if they have a single participant, very short audio, or audio exceeding an hour in length.": "Calls are not analyzed if they have a single participant, very short audio, or audio exceeding an hour in length.",
  "City": "City",
  "Collect Payment": "Collect Payment",
  "Collections": "Collections",
  "Communication Preferences": "Communication Preferences",
  "Contact Information": "Contact Information",
  "Contact created successfully": "Contact created successfully",
  "Contact creation error": "Contact creation error",
  "Contact update error": "Contact update error",
  "Contact updated successfully": "Contact updated successfully",
  "Copy ID": "Copy ID",
  "Country": "Country",
  "Create New Contact": "Create New Contact",
  "Create Payment Request": "Create Payment Request",
  "Create Task": "Create Task",
  "Current": "Current",
  "Custom": "Custom",
  "Custom Contact. Not a patient of record.": "Custom Contact. Not a patient of record.",
  "Done": "Done",
  "Due Date: {{dueDate}}": "Due Date: {{dueDate}}",
  "Easily monitor contacts with outstanding payments, upcoming birthdays, and who are overdue for an appointment.": "Easily monitor contacts with outstanding payments, upcoming birthdays, and who are overdue for an appointment.",
  "English": "English",
  "Error opening communication preferences. Try again.": "Error opening communication preferences. Try again.",
  "Failed to load notes.": "Failed to load notes.",
  "Female": "Female",
  "Filters": "Filters",
  "First Name": "First Name",
  "Forms": "Forms",
  "Forwarded": "Forwarded",
  "General Information": "General Information",
  "History": "History",
  "ID copied": "ID copied",
  "Imported from a CSV list. Not a patient of record.": "Imported from a CSV list. Not a patient of record.",
  "Inactive": "Inactive",
  "Insurance": "Insurance",
  "Integration": "Integration",
  "Last Name": "Last Name",
  "Lists": "Lists",
  "Load More": "Load More",
  "Locations": "Locations",
  "Looks like there's no history with this patient yet, but your story is just beginning.": "Looks like there's no history with this patient yet, but your story is just beginning.",
  "Male": "Male",
  "Message": "Message",
  "Missed": "Missed",
  "Missed call": "Missed call",
  "New Appointment": "New Appointment",
  "New Fax": "New Fax",
  "New Message": "New Message",
  "New Patient": "New Patient",
  "New Payment Request": "New Payment Request",
  "No Preference": "No Preference",
  "No email address to send to.": "No email address to send to.",
  "No locationId selected.": "No locationId selected.",
  "No message content": "No message content",
  "No name": "No name",
  "Nonbinary": "Nonbinary",
  "Notes": "Notes",
  "Oops...": "Oops...",
  "Other": "Other",
  "Outbound voicemails are not analyzed by Call Intelligence.": "Outbound voicemails are not analyzed by Call Intelligence.",
  "Overdue": "Overdue",
  "Overdue Balance: {{total}}": "Overdue Balance: {{total}}",
  "Overdue Services": "Overdue Services",
  "Overdue: {{overdueTime}}": "Overdue: {{overdueTime}}",
  "Overview": "Overview",
  "Payment History": "Payment History",
  "Payments": "Payments",
  "Phone Hours": "Phone Hours",
  "Phone Owner": "Phone Owner",
  "Phone Settings": "Phone Settings",
  "Postal Code": "Postal Code",
  "Preferred Name": "Preferred Name",
  "Prospective": "Prospective",
  "Province": "Province",
  "Remind {{name}} of Appt": "Remind {{name}} of Appt",
  "Request Payment": "Request Payment",
  "Review": "Review",
  "Save": "Save",
  "Schedule {{name}}": "Schedule {{name}}",
  "Select Language Preference": "Select Language Preference",
  "Select State": "Select State",
  "Send Form": "Send Form",
  "Send Reminder": "Send Reminder",
  "Send Vaccine History": "Send Vaccine History",
  "Send Vaccine Report": "Send Vaccine Report",
  "Showing active tasks for this {{contact}}. Navigate to Task Center for completed tasks.": "Showing active tasks for this {{contact}}. Navigate to Task Center for completed tasks.",
  "Showing history for {{startDate}} - {{endDate}}": "Showing history for {{startDate}} - {{endDate}}",
  "Showing last 12 months of history": "Showing last 12 months of history",
  "Sort by": "Sort by",
  "Spanish": "Spanish",
  "State": "State",
  "Street": "Street",
  "TODO INFORMATION": "TODO INFORMATION",
  "TODO: EYEWEAR": "TODO: EYEWEAR",
  "Tasks": "Tasks",
  "This Week ": "This Week ",
  "This contact was pulled in from your practice management system. You can only update your contact's language preference here.": "This contact was pulled in from your practice management system. You can only update your contact's language preference here.",
  "This user doesn't exist": "This user doesn't exist",
  "Today ": "Today ",
  "Tomorrow ": "Tomorrow ",
  "Total": "Total",
  "Total Overdue": "Total Overdue",
  "Total Overdue Patients": "Total Overdue Patients",
  "Total Uncollected Revenue": "Total Uncollected Revenue",
  "Total Upcoming Birthdays": "Total Upcoming Birthdays",
  "Turning {{newAge}} {{today}}": "Turning {{newAge}} {{today}}",
  "Unknown": "Unknown",
  "Unknown Contact": "Unknown Contact",
  "Unknown employee": "Unknown employee",
  "Unpaid Requests": "Unpaid Requests",
  "Upcoming Services": "Upcoming Services",
  "Update Contact": "Update Contact",
  "VMO": "VMO",
  "Waitlist": "Waitlist",
  "Was due ": "Was due ",
  "We are unable to transcribe and analyze this call. ": "We are unable to transcribe and analyze this call. ",
  "Wish {{name}} Happy Birthday": "Wish {{name}} Happy Birthday",
  "Zip Code": "Zip Code",
  "birthdate": "Birthdate",
  "email": "Email",
  "first name": "First Name",
  "gender": "Gender",
  "home phone": "Home Phone",
  "last name": "Last Name",
  "mobile phone": "Mobile Phone",
  "{{age}} yrs": "{{age}} yrs",
  "{{count}} Locations_one": "{{count}} Locations",
  "{{count}} Locations_other": "{{count}} Locations",
  "{{count}} invoice_one": "{{count}} invoice",
  "{{count}} invoice_other": "{{count}} invoice",
  "{{count}} invoices_one": "{{count}} invoices",
  "{{count}} invoices_other": "{{count}} invoices",
  "{{day}}, {{month}} {{year}} at {{time}}": "{{day}}, {{month}} {{year}} at {{time}}",
  "{{name}} turns {{age}} on {{day}}": "{{name}} turns {{age}} on {{day}}",
  "{{name}}'s eyewear is ready": "{{name}}'s eyewear is ready",
  "🎉 You have reached the end": "🎉 You have reached the end"
}
